import { render, staticRenderFns } from "./complain.vue?vue&type=template&id=35b4bf0a&scoped=true&"
import script from "./complain.vue?vue&type=script&lang=js&"
export * from "./complain.vue?vue&type=script&lang=js&"
import style0 from "./complain.vue?vue&type=style&index=0&id=35b4bf0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b4bf0a",
  null
  
)

export default component.exports